/**
 * Platform and WebKit / iOS Safari detection utility.
 * Applies optimal styling classes to the root <html> element for iOS/iPadOS and Safari.
 */

export function initIosSafariDetection() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const ua = navigator.userAgent || '';
  const isIosDevice = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

  if (isIosDevice) {
    document.documentElement.classList.add('is-ios');
  }
  if (isSafari || isIosDevice) {
    document.documentElement.classList.add('is-safari');
  }
  if (isIosDevice && isSafari) {
    document.documentElement.classList.add('is-ios-safari');
  }
}
